import { Select, Divider } from "antd";
import PropTypes from "prop-types";
import styles from "./CommunityMultiSelect.module.scss";

const truncate = (str, max = 22) =>
  str && str.length > max ? str.slice(0, max) + "…" : str;

const CommunityMultiSelect = ({
  communities,
  value = [],
  onChange,
  disabled,
  className,
  ...props
}) => {
  const options = (communities || []).map((community) => ({
    label: community.CommunityName,
    value: community.CommunityKey,
  }));

  const allValues = options.map((opt) => opt.value);
  const allSelected =
    allValues.length > 0 && value.length === allValues.length;

  const handleSelectAllToggle = () => {
    if (allSelected) {
      onChange([]);
    } else {
      onChange(allValues);
    }
  };

  const displayOptions = options.map((opt) => ({
    ...opt,
    label: truncate(opt.label),
  }));

  return (
    <Select
      mode="multiple"
      allowClear
      showSearch
      size="middle"
      maxTagCount={1}
      maxTagPlaceholder={(omittedValues) => `+ ${omittedValues.length} more`}
      filterOption={(input, option) => {
        const original = options.find((o) => o.value === option.value);
        return (original?.label ?? "")
          .toLowerCase()
          .includes(input.toLowerCase());
      }}
      optionRender={(option) => {
        const original = options.find((o) => o.value === option.value);
        return original?.label ?? option.label;
      }}
      className={`${styles.select}${className ? ` ${className}` : ""}`}
      placeholder="Select one or more communities:"
      options={displayOptions}
      value={value}
      onChange={onChange}
      disabled={disabled}
      dropdownRender={(menu) => (
        <>
          <div
            className={`ant-select-item ant-select-item-option ${styles.selectAll}`}
            onMouseDown={(e) => e.preventDefault()}
            onClick={handleSelectAllToggle}
          >
            <div className="ant-select-item-option-content">
              {allSelected ? "Clear All" : "Select All"}
            </div>
          </div>
          <Divider style={{ margin: "4px 0" }} />
          {menu}
        </>
      )}
      {...props}
    />
  );
};

CommunityMultiSelect.propTypes = {
  communities: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default CommunityMultiSelect;